import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TrackingHistoryService } from 'src/app/component/common-components/tracking-history/service/tracking-history.service';
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { HelperService } from 'src/app/service/helper.service';
import { StudentIdentifierTypes } from '../../../model/student-identifier-types.model';
import { StudentIdentifiers } from '../../../model/student-identifiers.model';
import { StudentHelperService } from '../../../service/student-helper.service';
import { StudentIdentifierTypeService } from '../../../service/student-identifier-type.service';
import { StudentService } from '../../../service/student.service';
import { StudentHelper2Service } from '../../../service/student-helper2.service';

@Component({
    selector: 'view-child-demographic-identifiers',
    templateUrl: './view-child-demographic-identifiers.component.html',
    styleUrl: './view-child-demographic-identifiers.component.scss'
})
export class ViewChildDemographicIdentifiersComponent implements OnInit {
    @Input() studentId!: number;
    @Input() studentHelperNumber: number = 1;
    msdNumber: string;

    studentIdentifiers: StudentIdentifiers[] = [];
    studentIdentifierTypes: StudentIdentifierTypes[] = [];
    studentIdentifiersToCreate: StudentIdentifiers[] = [];
    studentIdentifiersToUpdate: StudentIdentifiers[] = [];
    studentIdentifiersToDelete: StudentIdentifiers[] = [];

    childIdentifiers: StudentIdentifiers[] = [];
    localIdentifiers: StudentIdentifiers[] = [];
    coeStarIdentifiers: StudentIdentifiers[] = [];

    msdFound: boolean = false;
    msixFound: boolean = false;
    ssidFound: boolean = false;

    promises: Array<any> = [];

    getPropertyPipe = new GetPropertyPipe();

    subs: Subscription[] = [];

    isLoading: boolean = false;

    constructor(
        private studentService: StudentService,
        private studentIdentifierTypeService: StudentIdentifierTypeService,
        private studentHelper: StudentHelperService,
        private studentHelper2: StudentHelper2Service
    ) {}

    ngOnInit(): void {
        this.subscriptions();
        this.init();
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    init() {
        this.isLoading = true;
        this.studentIdentifiersToCreate = [];
        this.studentIdentifiersToUpdate = [];
        this.studentIdentifiersToDelete = [];

        this.getStudentIdentifiers();
        this.getStudentIdentifierTypes();
        Promise.all(this.promises).then((res) => {
            this.isLoading = false;
        });
    }

    subscriptions() {
        if (this.studentHelperNumber === 1) {
            let msdNumberSub = this.studentHelper.msdNumber$.subscribe((msdNumber) => {
                this.msdNumber = msdNumber;
            });
            this.subs.push(msdNumberSub);
        } else {
            let msdNumberSub = this.studentHelper2.msdNumber$.subscribe((msdNumber) => {
                this.msdNumber = msdNumber;
            });
            this.subs.push(msdNumberSub);
        }
    }

    getStudentIdentifiers() {
        let deferred = new Promise((resolve, reject) => {
            this.studentService.getIdentifiers(this.studentId).subscribe((res) => {
                if (res.identifiers) {
                    this.studentIdentifiers = res.identifiers;

                    this.studentIdentifiers.forEach((si) => {
                        switch (si.STUDENT_IDENTIFIER_TYPES.TYPE) {
                            case 'MSDNumber':
                                si.STUDENT_IDENTIFIER_TYPES.TYPE = 'MSD Number';
                                break;
                            case 'MSIXNumber':
                                si.STUDENT_IDENTIFIER_TYPES.TYPE = 'MSIX Number';
                                break;
                            case 'California State Student ID':
                                si.STUDENT_IDENTIFIER_TYPES.TYPE = 'SSID Number';
                                break;
                            default:
                                break;
                        }
                    });

                    this.childIdentifiers = [];
                    this.localIdentifiers = [];
                    this.coeStarIdentifiers = [];

                    this.studentIdentifiers.forEach((studentIdentifier) => {
                        switch (studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE) {
                            case 'MSDNumber':
                            case 'MSD Number':
                                // Handle duplicate MSD Numbers
                                this.childIdentifiers.findIndex((ci) => ci.IDENTIFIER_VALUE === studentIdentifier.IDENTIFIER_VALUE) < 0
                                    ? this.childIdentifiers.push(studentIdentifier)
                                    : null;
                                this.msdFound = true;
                                break;
                            case 'MSIXNumber':
                            case 'MSIX Number':
                                this.childIdentifiers.push(studentIdentifier);
                                this.msixFound = true;
                                break;
                            case 'California State Student ID':
                            case 'SSID Number':
                                this.childIdentifiers.push(studentIdentifier);
                                this.setSsidFound(true);
                                break;
                            case 'SCHOOL_DISTRICT_ID':
                            case 'DUES':
                            case 'DHS':
                            case 'Student_ID':
                            case '061062166':
                            case '063066670':
                            case '063768098':
                            case '063768452':
                            case '063773551':
                            case '063773791':
                            case '063775614':
                            case '064369666':
                            case '064269120':
                                this.localIdentifiers.push(studentIdentifier);
                                break;
                            case 'COEStar_Number':
                                this.coeStarIdentifiers.push(studentIdentifier);
                                break;
                            default:
                                break;
                        }
                    });

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    resolve('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getStudentIdentifierTypes() {
        let deferred = new Promise((resolve, reject) => {
            this.studentIdentifierTypeService.getIdentifierTypes().subscribe((res) => {
                if (res.identifierTypes) {
                    this.studentIdentifierTypes = res.identifierTypes;

                    this.studentIdentifierTypes.forEach((sit) => {
                        switch (sit.TYPE) {
                            case 'MSDNumber':
                                sit.TYPE = 'MSD Number';
                                break;
                            case 'MSIXNumber':
                                sit.TYPE = 'MSIX Number';
                                break;
                            case 'California State Student ID':
                                sit.TYPE = 'SSID Number';
                                break;
                            default:
                                break;
                        }
                    });

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    private setSsidFound(found: boolean) {
        if (found) {
            this.ssidFound = found;
        } else {
            this.ssidFound = found;
        }
    }
}
